import { render, staticRenderFns } from "./EmployeeDniNumberField.vue?vue&type=template&id=221a1d5c&"
import script from "./EmployeeDniNumberField.vue?vue&type=script&lang=js&"
export * from "./EmployeeDniNumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('221a1d5c')) {
      api.createRecord('221a1d5c', component.options)
    } else {
      api.reload('221a1d5c', component.options)
    }
    module.hot.accept("./EmployeeDniNumberField.vue?vue&type=template&id=221a1d5c&", function () {
      api.rerender('221a1d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/fields/EmployeeDniNumberField.vue"
export default component.exports